// Shared by the Intelligence nav menu (phones) and the project sidebar (desktop).
type IntelligencePage = readonly [label: string, path: string];

type IntelligenceGroup = {
    label: 'Feedback' | 'Customers' | 'Signals' | 'Sources';
    pages: readonly IntelligencePage[];
};

export const INTELLIGENCE_GROUPS: readonly IntelligenceGroup[] = [
    {
        label: 'Feedback',
        pages: [
            ['Overview', 'feedback/overview'],
            ['Inbox', 'feedback/inbox'],
            ['Insights', 'feedback/insights'],
            ['Taxonomy', 'feedback/taxonomy'],
        ],
    },
    {
        label: 'Customers',
        pages: [
            ['Customers', 'customers'],
            ['Customer insights', 'customer-insights'],
            ['User insights', 'user-insights'],
        ],
    },
    {
        label: 'Signals',
        pages: [
            ['Priority', 'priority'],
            ['Predictive signals', 'predictive/signals'],
            ['Alerts', 'alerts'],
            ['Backlog', 'backlog'],
        ],
    },
    { label: 'Sources', pages: [['Sources', 'sources']] },
];

export const INTELLIGENCE_PAGES: readonly IntelligencePage[] =
    INTELLIGENCE_GROUPS.flatMap((group) => group.pages);
